import React, { forwardRef } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import the plugin

// Register the required components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, ChartDataLabels); // Register the plugin

const LineChartCostRevovery = forwardRef((props, ref) => {
  const data = {
    labels: ['0', '1', '2', '3', '4', '5'],
    datasets: [
      {
        label: 'FireDos',
        data: props?.secondchartArrayData,
        fill: false,
        borderColor: 'rgba(79,129,189,255)',
        tension: 0.1,
        pointRadius: 6,
        pointBackgroundColor: 'rgba(79,129,189,255)',
        pointBorderColor: '#fff',
        pointHoverRadius: 7,
        pointStyle: 'rectRot',
        datalabels: {
          align: 'top',
          anchor: 'top',
          formatter: (value) => `${value}%`,
          color: 'rgba(79,129,189,255)',
      }
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide the default legend
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.raw !== null) {
              label += `${context.raw}%`;
            }
            return label;
          },
        },
      },
      datalabels: {
        display: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value) {
            return `${value}%`;
          },
          maxTicksLimit: 20,
          padding: 20
        },
      },
      x: {
        beginAtZero: true,
        ticks: {
          padding: 10 // Increase padding to separate labels from the edges
      }
      },
    },
  };

  return (
    <div ref={ref}>
      <Line data={data} options={options} />
    </div>
  );
});

export default LineChartCostRevovery;
